<template>
    <div class="article-contact">
        <p>We'd love to hear about your project!</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
